import React, { forwardRef } from 'react';
import { Link, useLocation } from "react-router-dom";
import {
    FAVOURITES_ROUTE,
    GLOBAL_REVIEWS_ROUTE,
    MAIN_ROUTE
} from "../../../../utils/consts";
import { observer } from "mobx-react-lite";

import logo from "../../../../Assets/21.png";
import styles from './NavBar.module.css';

import { reachGoal } from "../../../../utils/metrika/metrika";
import UserMiniProfile from "../../../profile/UserMiniProfile/UserMiniProfile";

const NavBar = observer(forwardRef((props, ref) => {
    const location = useLocation();

    const isFavouritesPage =
        location.pathname.startsWith(FAVOURITES_ROUTE);

    const isReviewsPage =
        location.pathname.startsWith(GLOBAL_REVIEWS_ROUTE);

    return (
        <div
            className={`${styles.navBarWrapper} ${isFavouritesPage ? styles.favouritesPageMod : ''}`}
            ref={ref}
        >
            <div className="container-custom">
                <div className={styles.navBarContent}>
                    <Link
                        to={MAIN_ROUTE}
                        onClick={() => reachGoal("history.push(MAIN_ROUTE) LOGO")}
                        className={styles.logoButton}
                        aria-label="Перейти на главную страницу Arento"
                    >
                        <img
                            alt="Arento"
                            src={logo}
                            className={styles.logoImage}
                        />
                    </Link>

                    <div
                        className={styles.userActions}
                        data-prerender-remove="true"
                    >
                        <Link
                            to={GLOBAL_REVIEWS_ROUTE}
                            className={`${styles.reviewButton} ${isReviewsPage ? styles.reviewButtonActive : ''}`}
                            onClick={() => reachGoal("history.push(GLOBAL_REVIEWS_ROUTE)")}
                            aria-label="Отзывы гостей"
                            title="Отзывы гостей"
                        >
                            Отзывы
                        </Link>

                        <UserMiniProfile />
                    </div>
                </div>
            </div>
        </div>
    );
}));

export default NavBar;
